import { gql } from '@apollo/client';

export default gql`
  mutation createCustomerLink($id: String) {
    createCustomerLink(id: $id) {
      ok
      message
      data
      error
    }
  }
`;
